import type { ProjectId } from 'common/types'

import type { GeomateTabType } from './types'
import { isCoreTab } from './types'
import { createUrlTo } from './urls'

export function constructBrowserTabUrl(type: GeomateTabType, projectId: ProjectId) {
  if (isCoreTab(type)) return createUrlTo({ base: 'Project', path: projectId })

  switch (type) {
    case 'Stratigraphy':
      return createUrlTo({ base: 'Stratigraphy', query: { projectId } })
    case 'BulkImport':
      return createUrlTo({ base: 'Project', path: [projectId, 'bulk'] })
    case 'Cartography':
      return createUrlTo({ base: 'Cartography', query: { projectId } })
    case 'Modeling':
      return createUrlTo({ base: 'Modeling', query: { projectId } })
    case 'InterpretationBrowser':
      return createUrlTo({ base: 'Interpretation', query: { projectId } })
    case 'DataManager':
      return createUrlTo({ base: 'DataManager', query: { projectId } })
    case 'CrossPlotBrowser':
      return createUrlTo({ base: 'CrossPlot', query: { projectId } })
  }
}
